const portalElementAsArray = document.querySelectorAll<HTMLElement>("#overlay-root");
export const portalElement = portalElementAsArray[0];